const OFFSET_X = 22;
const OFFSET_Y = 22;
const LERP = 0.2;
const ROTATION_SPEED = 20; // degrees per second — full turn ~18s

export function initCursorBox() {
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
  const el = document.querySelector('.cursor-box');
  if (!el) return;

  let tx = window.innerWidth / 2;
  let ty = window.innerHeight / 2;
  let cx = tx;
  let cy = ty;
  let rotation = 0;
  let visible = false;
  let last = performance.now();

  function frame(now) {
    const dt = (now - last) / 1000;
    last = now;

    cx += (tx - cx) * LERP;
    cy += (ty - cy) * LERP;
    rotation = (rotation + ROTATION_SPEED * dt) % 360;

    const x = visible ? cx + OFFSET_X : -9999;
    const y = visible ? cy + OFFSET_Y : -9999;
    el.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${rotation}deg)`;

    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  window.addEventListener('pointermove', (e) => {
    tx = e.clientX;
    ty = e.clientY;
    visible = true;
  }, { passive: true });

  document.documentElement.addEventListener('pointerleave', () => {
    visible = false;
  });
}
